import { apiGet } from './utils';

export interface InfoRecord {
  uuid: string;
  identity: string;
  parent_uuid: string;
  associated_type: string;
  associated_uuid: string;
  data: string;
  datatype: string;
  date_created: string;
}

export interface InfoListResponse {
  items: InfoRecord[];
  cursor: string | null;
  has_more: boolean;
}

export interface ListByParentParams {
  parent_type: string;
  parent_uuid: string;
  associated_type?: string;
  cursor?: string;
}

export const infoApi = {
  async listByParent(params: ListByParentParams): Promise<InfoListResponse> {
    return apiGet<InfoListResponse>('/info/list/by-parent', params as unknown as Record<string, string>);
  },
};
